module.exports = __webpack_public_path__ + "media/images/ke_logo-cde6cdda2be8ff871486df0ebf36e800.png";